export const LEVEL_COLORS = Object.freeze({ B: "#C5AD7D", I: "#7DA4B5", A: "#75AC9C", E: "#5F917E" });
export const levelColor = level => LEVEL_COLORS[level] || null;
export const levelAccent = level => levelColor(level) ? { borderInlineStart: `3px solid ${levelColor(level)}` } : undefined;
